import React, { createContext, useState } from 'react';
import { renderText } from './utils';

export const SMSChatContext = createContext({});

export const SMSChatProvider = ({ children }) => {
  const [conversationsList, setConversationsList] = useState([]);
  const [selectedConversation, setSelectedConversation] = useState(null);
  const [messages, setMessages] = useState([]);
  const [isLoadingConversations, setIsLoadingConversations] = useState(false);
  const [isLoadingMessages, setIsLoadingMessages] = useState(false);
  const [hasMoreConversations, setHasMoreConversations] = useState(true);
  const [hasMoreMessages, setHasMoreMessages] = useState(true);
  const [conversationsPage, setConversationsPage] = useState(1);
  const [messagesPage, setMessagesPage] = useState(1);
  const [search, setSearch] = useState('');
  
  // Optimistic UI updates
const updateConversationPreview = (conversationId, message, lastCreatedAt) => {
  setConversationsList((prev) => {
    const index = prev.findIndex((c) => c.id === conversationId);
    if (index === -1) return prev;

    const updated = { ...prev[index] };

    updated.lastMessagePreview = renderText(message);

    updated.lastMessageAt = lastCreatedAt || new Date();
    updated.unreadCount =
      selectedConversation?.id === conversationId
        ? 0
        : (updated.unreadCount + 1);

    // Move to top
    const newList = [...prev];
    newList.splice(index, 1);
    return [updated, ...newList];
  });
};


  return (
    <SMSChatContext.Provider
      value={{
        conversationsList,
        setConversationsList,
        selectedConversation,
        setSelectedConversation,
        messages,
        setMessages,
        isLoadingConversations,
        setIsLoadingConversations,
        isLoadingMessages,
        setIsLoadingMessages,
        hasMoreConversations,
        setHasMoreConversations,
        hasMoreMessages,
        setHasMoreMessages,
        conversationsPage,
        setConversationsPage,
        messagesPage,
        setMessagesPage,
        search,
        setSearch,
        updateConversationPreview,
      }}
    >
      {children}
    </SMSChatContext.Provider>
  );
};
